import { CommonModule as NgCommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IconKey } from '@common/classes/icons';
import { PropertyFunction } from '@common/models/util.interface';
import { NgIconComponent } from '@ng-icons/core';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '@progress/kendo-angular-tooltip';

@Component({
    selector: 'app-button',
    standalone: true,
    imports: [NgCommonModule, NgIconComponent, TooltipModule, TranslateModule],
    templateUrl: './button.component.html',
    encapsulation: ViewEncapsulation.None,
    host: { '[attr.class]': 'btnClass' }
})
export class ButtonComponent {
    @Input() variant:
        | 'primary'
        | 'secondary'
        | 'danger'
        | 'warning'
        | 'info'
        | 'success'
        | 'link'
        | 'light'
        | 'excel'
        | 'pdf'
        | 'csv';
    @Input() class: string;
    @Input() icon: IconKey | PropertyFunction<IconKey>;
    @Input() iconPosition: 'start' | 'end';
    @Input() iconClass: string | string[] | Set<string> | { [klass: string]: any };
    @Input() iconOnly?: boolean | PropertyFunction<boolean>;
    @Input() disabled: boolean;
    @Input() loading: boolean;
    @Input() type: 'button' | 'submit' = 'button';
    @Input() size: 'sm' | 'md' | 'lg' = 'md';
    @Input() tooltip: string | undefined;
    @Input() tooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';
    @Output() clicked: EventEmitter<void> = new EventEmitter();

    get btnClass() {
        return '';
    }
}
